import { useOrgIdSelector } from 'store/selectors/organizationSelectors/orgSettingsSelector';

type MainJane = {
  agencyCommunity?: { id: number } | null;
  primaryCommunity?: { organization?: { id: number } | null } | null;
};

type AgencyJaneParams = {
  mainJane?: Nullable<MainJane>;
  sentToAgencies: boolean;
  orderCommunityOrgId?: Nullable<number>;
};

export const useIsSentToAgencyJane = ({
  mainJane,
  sentToAgencies,
  orderCommunityOrgId,
}: AgencyJaneParams): boolean => {
  const orgId = useOrgIdSelector();
  const isSentToAgencyJane =
    sentToAgencies &&
    (!!mainJane?.agencyCommunity ||
      !!(
        mainJane &&
        orgId &&
        orgId === orderCommunityOrgId &&
        mainJane?.primaryCommunity?.organization?.id &&
        mainJane.primaryCommunity.organization.id !== orgId
      ));

  return isSentToAgencyJane;
};

export const useIsAgencyShift = ({
  mainJane,
  sentToAgencies,
  orderCommunityOrgId,
}: {
  sentToAgencies?: Nullable<boolean>;
} & AgencyJaneParams): boolean => {
  const isAgencyJane = useIsSentToAgencyJane({ mainJane, sentToAgencies, orderCommunityOrgId });

  const isAgencyShift =
    sentToAgencies &&
    ((mainJane && isAgencyJane) ||
      // For unassigned shifts we just need to check if it's sent to agencies
      !mainJane);

  return isAgencyShift;
};
